import React from "react";
import ParticlesBg from "particles-bg";

const switchColors = ["#D70035","#00608D","#FFF352","#a3ea34"];
//const random = Math.floor(Math.random() * switchColors.length);

let config = {
  num: [4, 7],
  rps: 1.5,
  radius: [5, 40],
  life: [3, 3],
  v: [1, 2],
  tha: [-40, 40],
  // body: "./img/icon.png", // Whether to render pictures
  rotate: [0, 20],
  alpha: [0.75, 1],
  scale: [0.1, 2],
  position: "all", // all or center or {x:1,y:1,width:100,height:100}
  color: ["random","#a3ea34"],
  cross: "cross", // cross or bround
  random: 10,  // or null,
  g: 0.1,    // gravity
  // f: [2, -1], // force
  onParticleUpdate: (ctx, particle) => {
      ctx.beginPath();
     // ctx.rect(particle.p.x, particle.p.y, particle.radius * 2, particle.radius * 2);
     // ctx.fillStyle = particle.color;
     // ctx.fill();

     ctx.arc(particle.p.x, particle.p.y, particle.radius * 2, 0, 2 * Math.PI);

     ctx.strokeStyle = particle.color;
    // ctx.strokeStyle = switchColors[random];
     ctx.stroke();

      ctx.closePath();
  }
};

function Particle() {
  return (
    <ParticlesBg type="custom" config={config} bg={true}/>
  );
}

export default Particle;
